import { createElement, memo, useState, useEffect, useCallback } from '@max/max';
import SlideModal from '@max/leez-slide-modal';
import View from '@hfe/max-view';
import CitySelection from './CitySelection';
import { screenHeight, statusBarHeight } from '../until';
const isWeb = true;
function CitySelectionModal(p) {
    const [visible, setVisible] = useState(p.visible);
    const [city, setCity] = useState(p.city);
    useEffect(() => {
        setCity(p.city);
    }, [p.city]);
    const receiveCity = useCallback(city => {
        var _a, _b, _c, _d;
        (_a = p === null || p === void 0 ? void 0 : p._communication) === null || _a === void 0 ? void 0 : _a.emit('cityChanged', {
            title: city === null || city === void 0 ? void 0 : city.name,
            value: (_b = city === null || city === void 0 ? void 0 : city.id) === null || _b === void 0 ? void 0 : _b.toString()
        });
        console.log('cityChanged', {
            title: city === null || city === void 0 ? void 0 : city.name,
            value: (_c = city === null || city === void 0 ? void 0 : city.id) === null || _c === void 0 ? void 0 : _c.toString()
        });
        setCity(city === null || city === void 0 ? void 0 : city.name);
        setVisible(false);
        p === null || p === void 0 ? void 0 : p.onCityChange({
            title: city === null || city === void 0 ? void 0 : city.name,
            value: (_d = city === null || city === void 0 ? void 0 : city.id) === null || _d === void 0 ? void 0 : _d.toString()
        });
    }, []);
    useEffect(() => {
        setVisible(p.visible);
    }, [p.visible]);
    return <View>
      <SlideModal visible={visible} showHeader={false} showCloseBtn={false} maskClosable addBottomSpace={false} modalMaxHeight={100} contentStyle={{
        margin: 0,
        paddingLeft: 0,
        paddingRight: 0,
        padding: 0
    }} style={{
        borderTopLeftRadius: '30rpx',
        borderTopRightRadius: '30rpx',
        maxHeight: isWeb ? '90vh' : screenHeight - statusBarHeight,
        height: undefined
    }}>
        <CitySelection emitCity={receiveCity} cityData={p.cityData} city={city} onClose={p === null || p === void 0 ? void 0 : p.onClose} locationCity={p === null || p === void 0 ? void 0 : p.city} _communication={p === null || p === void 0 ? void 0 : p._communication}/>
      </SlideModal>
    </View>;
}
export default memo(CitySelectionModal);
